import React, { SVGProps } from "react";

export default function GroupsIcon({ color, ...props }: SVGProps<any>) {
  return (
    <svg viewBox="0 0 27 28" width={27} height={28} {...props}>
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.641}>
        <path d="M21.558 3.522v-.254c-.066-.73-.82-1.309-1.768-1.358h-.333c-5.245-.267-10.5-.267-15.745 0h-.333c-.947.049-1.702.627-1.768 1.358l-.02.254a69.744 69.744 0 000 12.07l.02.25c.066.73.82 1.309 1.773 1.358l.648.029c.82.04 1.64.075 2.461.102l4.899 4.874v-4.788c2.798 0 5.592-.07 8.381-.213.948-.05 1.699-.628 1.764-1.354v-.258c.356-4.015.363-8.054.02-12.07z" />
        <path d="M23.872 6.012c.947.05 1.702.628 1.768 1.358v.255a69.744 69.744 0 010 12.07v.25c-.066.73-.82 1.308-1.772 1.358l-.649.028c-.82.041-1.64.075-2.461.103l-4.919 4.874V21.52h-.234c-1.132 0-.62 0-1.752-.041M6.777 9.557h9.575M6.777 6.135h9.575m-9.575 6.839h4.787" />
      </g>
    </svg>
  );
}
